﻿<template>
  <div class="place">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="90px"
      class="demo-ruleForm"
      size="small"
    >
      <!-- 发件人 -->
      <el-row :gutter="10" class="border-col">
        <el-col :span="12">
          <div class="place-title">
            {{ $t('order.fplace.title.shipperInfo') }}
          </div>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <el-select
            v-model="sendSelectValue"
            :placeholder="$t('order.fplace.placeholder.selectSenderAddress')"
            filterable
            size="small"
            style="width: 180px; margin-left: 10px"
            @change="selectSendAddr"
          >
            <el-option
              v-for="(item, index) in send_list"
              :key="index"
              :label="item.realname"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.name')" prop="send_data.realname">
            <el-input v-model="ruleForm.send_data.realname" :placeholder="$t('order.fplace.placeholder.enterName')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.company')" prop="send_data.company">
            <el-input v-model="ruleForm.send_data.company" :placeholder="$t('order.fplace.placeholder.enterCompany')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.country')" prop="send_data.country">
            <el-select
              v-model="ruleForm.send_data.country"
              filterable
              :placeholder="$t('order.fplace.placeholder.selectCountry')"
              style="width: 100%"
              @change="handleSendChange"
            >
              <el-option
                v-for="(item, index) in countryList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.stateProvince')" label-width="120px" prop="send_data.province">
            <el-select
              v-model="ruleForm.send_data.province"
              filterable
              :placeholder="$t('order.fplace.placeholder.selectState')"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in sendProvinceList"
                :key="index"
                :label="item.label"
                :value="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.city')" prop="send_data.city">
            <el-input v-model="ruleForm.send_data.city" :placeholder="$t('order.fplace.placeholder.enterCity')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.zipCode')" prop="send_data.zcode">
            <el-input
              v-model="ruleForm.send_data.zcode"
              :placeholder="$t('order.fplace.placeholder.enterZipCode')"
              @blur="getCityInfo(1)"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.address1')" prop="send_data.address_one">
            <el-input v-model="ruleForm.send_data.address_one" :placeholder="$t('order.fplace.placeholder.enterAddress1')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.address2')" prop="send_data.address_two">
            <el-input v-model="ruleForm.send_data.address_two" :placeholder="$t('order.fplace.placeholder.enterAddress2')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.address3')" prop="send_data.address_three">
            <el-input v-model="ruleForm.send_data.address_three" :placeholder="$t('order.fplace.placeholder.enterAddress3')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.phone')" prop="send_data.mobile">
            <el-input v-model="ruleForm.send_data.mobile" :placeholder="$t('order.fplace.placeholder.enterPhone')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.email')" prop="send_data.email">
            <el-input v-model="ruleForm.send_data.email" :placeholder="$t('order.fplace.placeholder.enterEmail')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 发件人操作按钮：单独一行，避免与地址3挤在同一列 -->
      <el-row :gutter="10" style="margin-bottom: 18px">
        <el-col :span="24" style="text-align: right">
          <el-button type="warning" @click="clearAddress(1)" size="small" class="add-select-btn"
            >{{ $t('order.fplace.button.clear') }}</el-button
          >
          <el-button type="primary" @click="swapAddress" size="small" class="add-select-btn">{{ $t('order.fplace.button.swapAddress') }}</el-button>
          <!-- <el-button type="primary" @click="handleResolution(1)" size="small" class="add-select-btn">{{ $t('order.fplace.resolution.jiexidizhi') }}</el-button> -->
          <el-button
            type="success"
            @click="addAddress('ruleForm', 1)"
            size="small"
            class="add-select-btn"
            >{{ $t('order.fplace.button.saveToAddressBook') }}</el-button
          >
        </el-col>
      </el-row>
      <!-- 收件人 -->
      <el-row :gutter="10" class="border-col">
        <el-col :span="12">
          <div class="place-title">{{ $t('order.fplace.title.consigneeInfo') }}</div>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <el-select
            v-model="FbaValue"
            :placeholder="$t('order.fplace.placeholder.selectFbaAddress')"
            filterable
            size="small"
            style="width: 180px; margin-left: 10px"
            @change="selectFBAAddr"
          >
            <el-option
              v-for="(item, index) in fbaLists"
              :key="index"
              :label="item.fba_code"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="receiveSelectValue"
            filterable
            :placeholder="$t('order.fplace.placeholder.selectReceiverAddress')"
            size="small"
            style="width: 180px; margin-left: 10px"
            @change="selectReceiveAddr"
          >
            <el-option
              v-for="(item, index) in receive_list"
              :key="index"
              :label="item.realname"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.name')" prop="receive_data.realname">
            <el-input v-model="ruleForm.receive_data.realname" :placeholder="$t('order.fplace.placeholder.enterName')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.company')" prop="receive_data.company">
            <el-input v-model="ruleForm.receive_data.company" :placeholder="$t('order.fplace.placeholder.enterCompany')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.country')" prop="receive_data.country">
            <el-select
              v-model="ruleForm.receive_data.country"
              filterable
              :placeholder="$t('order.fplace.placeholder.selectCountry')"
              style="width: 100%"
              @change="handleReceiveChange"
            >
              <el-option
                v-for="(item, index) in countryList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.stateProvince')" label-width="120px" prop="receive_data.province">
            <el-select
              v-model="ruleForm.receive_data.province"
              filterable
              :placeholder="$t('order.fplace.placeholder.selectState')"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in receiveProvinceList"
                :key="index"
                :label="item.label"
                :value="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.city')" prop="receive_data.city">
            <el-input v-model="ruleForm.receive_data.city" :placeholder="$t('order.fplace.placeholder.enterCity')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.zipCode')" prop="receive_data.zcode">
            <el-input
              v-model="ruleForm.receive_data.zcode"
              :placeholder="$t('order.fplace.placeholder.enterZipCode')"
              @blur="getCityInfo(2)"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.address1')" prop="receive_data.address_one">
            <el-input
              v-model="ruleForm.receive_data.address_one"
              :placeholder="$t('order.fplace.placeholder.enterAddress1')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.address2')" prop="receive_data.address_two">
            <el-input
              v-model="ruleForm.receive_data.address_two"
              :placeholder="$t('order.fplace.placeholder.enterAddress2')"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.address3')" prop="receive_data.address_three">
            <el-input v-model="ruleForm.receive_data.address_three" :placeholder="$t('order.fplace.placeholder.enterAddress3')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.phone')" prop="receive_data.mobile">
            <el-input v-model="ruleForm.receive_data.mobile" :placeholder="$t('order.fplace.placeholder.enterPhone')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.email')" prop="receive_data.email">
            <el-input v-model="ruleForm.receive_data.email" :placeholder="$t('order.fplace.placeholder.enterEmail')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 收件人操作按钮：单独一行，避免与地址3挤在同一列 -->
      <el-row :gutter="10" style="margin-bottom: 18px">
        <el-col :span="24" style="text-align: right">
          <el-button type="warning" @click="clearAddress(2)" size="small" class="add-select-btn"
            >{{ $t('order.fplace.button.clear') }}</el-button
          >
          <el-button
            type="warning"
            @click="addAddress('ruleForm', 3)"
            size="small"
            class="add-select-btn"
            >{{ $t('order.fplace.button.verifyAddress') }}</el-button
          >
          <el-button type="primary" @click="swapAddress" size="small" class="add-select-btn">{{ $t('order.fplace.button.swapAddress') }}</el-button>
          <!-- <el-button type="primary" @click="handleResolution(2)" size="small" class="add-select-btn">{{ $t('order.fplace.resolution.jiexidizhi') }}</el-button> -->
          <el-button
            type="success"
            @click="addAddress('ruleForm', 2)"
            size="small"
            class="add-select-btn"
            >{{ $t('order.fplace.button.saveToAddressBook') }}</el-button
          >
        </el-col>
      </el-row>
      <!-- 货运/商品 -->
      <el-row :gutter="10" class="border-col">
        <el-col :span="12">
          <div class="place-title">{{ $t('order.fplace.title.cargoGoods') }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item class="is-no-asterisk" :label="$t('order.fplace.label.logisticsChannel')" prop="goods_info.pservice_type">
            <el-select
              v-model="ruleForm.goods_info.pservice_type"
              :placeholder="$t('order.fplace.placeholder.selectLogisticsChannel')"
              style="width: 100%"
              @change="changePservice"
            >
              <el-option
                v-for="(item, index) in channelList"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label-width="100px" :label="$t('order.fplace.label.ecommerceOrderNo')" prop="goods_info.hb_order_sn">
            <el-input
              v-model="ruleForm.goods_info.hb_order_sn"
              :placeholder="$t('order.fplace.placeholder.enterEcommerceOrderNo')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.labelRemark')" prop="goods_info.order_remark">
            <el-input
              v-model="ruleForm.goods_info.order_remark"
              :placeholder="$t('order.fplace.placeholder.enterLabelRemark')"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.remarks')" prop="goods_info.note">
            <el-input v-model="ruleForm.goods_info.note" :placeholder="$t('order.fplace.placeholder.enterRemarks')"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.shipDate')" prop="goods_info.shipment_date">
            <el-date-picker
              v-model="ruleForm.goods_info.shipment_date"
              style="width: 100%"
              type="date"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              :placeholder="$t('order.fplace.placeholder.selectShipDate')"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.signatureRequired')" prop="goods_info.is_sign">
            <el-select
              v-model="ruleForm.goods_info.is_sign"
              :placeholder="$t('order.fplace.placeholder.selectSignature')"
              style="width: 100%"
            >
              <el-option :label="$t('order.fplace.options.signature.noSignature')" :value="0"></el-option>
              <el-option :label="$t('order.fplace.options.signature.adultSignature')" :value="1"></el-option>
              <el-option :label="$t('order.fplace.options.signature.standardSignature')" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.bookingConfirmationNumber')" prop="goods_info.booking_confirmation_number">
            <el-input
              v-model="ruleForm.goods_info.booking_confirmation_number"
              :placeholder="$t('order.fplace.placeholder.enterBookingConfirmationNumber')"
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 预约取件 -->
      <el-row :gutter="10" class="border-col">
        <el-col :span="12">
          <div class="place-title">
            <el-checkbox
              v-model="is_qus"
              @change="handleCheck"
              style="margin-right: 5px"
            ></el-checkbox
            >{{ $t('order.fplace.title.scheduledPickup') }}
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="is_qus">
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.name')" prop="q_data.realname">
            <el-input
              :disabled="!is_qus"
              v-model="ruleForm.q_data.realname"
              :placeholder="$t('order.fplace.placeholder.enterName')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.company')" prop="q_data.company">
            <el-input
              :disabled="!is_qus"
              v-model="ruleForm.q_data.company"
              :placeholder="$t('order.fplace.placeholder.enterCompany')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.country')" prop="q_data.country">
            <el-select
              :disabled="!is_qus"
              filterable
              v-model="ruleForm.q_data.country"
              :placeholder="$t('order.fplace.placeholder.selectCountry')"
              style="width: 100%"
              @change="handleQChange"
            >
              <!-- <el-option
                v-for="(item, index) in countryList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option> -->
              <el-option label="United States" value="United States"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.stateProvince')" prop="q_data.province">
            <el-select
              :disabled="!is_qus"
              filterable
              v-model="ruleForm.q_data.province"
              :placeholder="$t('order.fplace.placeholder.selectState')"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in qProvinceList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="is_qus">
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.city')" prop="q_data.city">
            <el-input
              :disabled="!is_qus"
              v-model="ruleForm.q_data.city"
              :placeholder="$t('order.fplace.placeholder.enterCity')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.zipCode')" prop="q_data.zcode">
            <el-input
              :disabled="!is_qus"
              v-model="ruleForm.q_data.zcode"
              :placeholder="$t('order.fplace.placeholder.enterZipCode')"
              @blur="getCityInfo(3)"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.address1')" prop="q_data.address_one">
            <el-input
              :disabled="!is_qus"
              v-model="ruleForm.q_data.address_one"
              :placeholder="$t('order.fplace.placeholder.enterAddress1')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.address2')" prop="q_data.address_two">
            <el-input
              :disabled="!is_qus"
              v-model="ruleForm.q_data.address_two"
              :placeholder="$t('order.fplace.placeholder.enterAddress2')"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="is_qus">
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.phone')" prop="q_data.mobile">
            <el-input
              :disabled="!is_qus"
              v-model="ruleForm.q_data.mobile"
              :placeholder="$t('order.fplace.placeholder.enterPhone')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" style="text-align: right">
          <el-button type="warning" @click="clearAddress(3)" size="small" class="add-select-btn"
            >{{ $t('order.fplace.button.clear') }}</el-button
          >
        </el-col>
      </el-row>
      <!-- 封装信息 -->
      <el-row :gutter="10" class="border-col" v-if="is_qus">
        <el-col :span="12">
          <div class="place-title">{{ $t('order.fplace.title.packagingInfo') }}</div>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="is_qus">
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.totalPackages')" prop="q_package.package_all_num">
            <el-input
              :disabled="!is_qus"
              v-model="ruleForm.q_package.package_all_num"
              :placeholder="$t('order.fplace.placeholder.enterTotalPackages')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.totalWeight')" prop="q_package.all_weight">
            <el-input
              :disabled="!is_qus"
              v-model="ruleForm.q_package.all_weight"
              :placeholder="$t('order.fplace.placeholder.enterTotalWeight')"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.pickupDate')" prop="q_package.q_date">
            <el-date-picker
              :disabled="!is_qus"
              v-model="ruleForm.q_package.q_date"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
              :picker-options="pickupDatePickerOptions"
              :placeholder="$t('order.fplace.placeholder.selectPickupDate')"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10" v-if="is_qus">
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.readyTime')" prop="q_package.q_time">
            <el-select
              :disabled="!is_qus"
              v-model="ruleForm.q_package.q_time"
              :placeholder="$t('order.fplace.placeholder.selectReadyTime')"
              style="width: 100%"
              @change="changeTime"
            >
              <el-option
                v-for="(item, index) in qtimelist"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$t('order.fplace.label.latestTime')" prop="q_package.q_endtime">
            <el-select
              :disabled="!is_qus"
              v-model="ruleForm.q_package.q_endtime"
              :placeholder="$t('order.fplace.placeholder.selectLatestTime')"
              style="width: 100%"
            >
              <el-option
                v-for="(item, index) in qendtimelist"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$t('order.fplace.label.specialInstructions')" prop="q_package.package_remark">
            <el-input
              :disabled="!is_qus"
              type="textarea"
              :rows="2"
              v-model="ruleForm.q_package.package_remark"
              :placeholder="$t('order.fplace.placeholder.enterSpecialInstructions')"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 包裹 -->
      <el-row :gutter="10" class="border-col">
        <el-col :span="24">
          <div class="place-title" style="display: flex">
            {{ $t('order.fplace.title.packageInfo') }}
            <el-radio-group v-model="pa_unit" size="small" style="margin-left: 10px">
              <el-radio-button :label="$t('order.fplace.unit.lbIn')" :value="1"></el-radio-button>
              <el-radio-button :label="$t('order.fplace.unit.kgCm')" :value="2"></el-radio-button>
            </el-radio-group>
            <span class="tips">{{ $t('order.fplace.tips.weightDimensions') }}</span>
          </div>
        </el-col>
      </el-row>
      <div class="parcel-item" v-for="(item, pIndex) in ruleForm.package_list" :key="pIndex">
        <div class="parcel-top">
          <span class="parcel-title">{{ pIndex + 1 }}-{{ $t('order.fplace.title.packageInfo') }}</span>
          <i
            style="font-size: 20px; margin: 0 10px; color: #409dfe; cursor: pointer"
            class="el-icon-circle-plus-outline"
            @click="addParcel"
          ></i>
          <i
            style="font-size: 20px; color: #f56c6c; cursor: pointer; margin-right: 10px"
            class="el-icon-remove-outline"
            v-if="ruleForm.package_list.length > 1"
            @click="delParcel(pIndex)"
          ></i>
        </div>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('order.fplace.label.packageType')" label-width="110px">
              <el-select v-model="item.pa_type" style="width: 100%" @change="(val) => handlePackageTypeChange(val, pIndex)">
                <el-option
                  :label="item.label"
                  :value="item.label"
                  v-for="(item, index) in pa_type_list"
                  :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$t('order.fplace.label.sku')"
              label-width="110px"
              :prop="`package_list[${pIndex}][Sku]`"
              :rules="rules.Sku"
            >
              <el-input v-model="item.Sku"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$t('order.fplace.label.packageQuantity')"
              label-width="110px"
              :prop="`package_list[${pIndex}][pa_num]`"
              :rules="rules.pa_num"
            >
              <div class="parcel-lwh">
                <el-input-number
                  v-model="item.pa_num"
                  :step="1"
                  style="width: 180px"
                ></el-input-number>
                <el-button
                  type="warning"
                  size="small"
                  @click="copyParcel(pIndex, item)"
                  style="margin-left: 10px"
                  >{{ $t('order.fplace.button.copyPackage') }}</el-button
                >
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item
              :label="pa_unit == $t('order.fplace.unit.lbIn') ? $t('order.fplace.label.dimensions') + '(' + $t('order.fplace.unit.in') + ')' : $t('order.fplace.label.dimensions') + '(' + $t('order.fplace.unit.cm') + ')'"
              label-width="110px"
              :prop="`package_list[${pIndex}][pa_length]`"
              :rules="(!item.pa_type || item.pa_type == 'Your Packaging') ? rules.pa_length : []"
            >
              <div class="parcel-lwh">
                <el-input
                  type="number"
                  :controls="false"
                  v-model="item.pa_length"
                  style="width: 100px"
                ></el-input
                >*
                <el-input
                  type="number"
                  :controls="false"
                  v-model="item.pa_width"
                  style="width: 100px"
                  @blur="$refs.ruleForm.validateField(`package_list[${pIndex}][pa_length]`)"
                ></el-input
                >*
                <el-input
                  type="number"
                  :controls="false"
                  v-model="item.pa_height"
                  style="width: 100px"
                  @blur="$refs.ruleForm.validateField(`package_list[${pIndex}][pa_length]`)"
                ></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="pa_unit == $t('order.fplace.unit.lbIn') ? $t('order.fplace.label.weight') + '(' + $t('order.fplace.unit.lb') + ')' : $t('order.fplace.label.weight') + '(' + $t('order.fplace.unit.kg') + ')'"
              label-width="110px"
              :prop="`package_list[${pIndex}][pa_lb]`"
              :rules="rules.pa_lb"
            >
              <div class="parcel-lwh">
                <el-input
                  type="number"
                  :controls="false"
                  v-model="item.pa_lb"
                  style="width: 100%"
                ></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :label="$t('order.fplace.label.declaredValue')" label-width="110px">
              <div class="parcel-lwh">
                <el-input v-model="item.insurance" style="width: 160px">
                  <template slot="prepend">{{ $t('order.fplace.unit.currency') }}</template>
                </el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item  :prop="`package_list[${pIndex}][itemQty]`" :label="$t('order.fplace.label.itemQtyValue')" label-width="110px">
              <div class="parcel-lwh">
                <el-input v-model="item.itemQty" style="width: 160px"></el-input>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <!-- 包裹合计：总重量 / 总体积重量(长×宽×高÷系数,多包裹按数量相加) -->
      <el-row :gutter="10">
        <el-col :span="24">
          <div style="display:flex;flex-wrap:wrap;gap:12px 48px;align-items:center;margin:6px 0 12px;padding:10px 16px;background:#ecf5ff;border:1px solid #d9ecff;border-radius:4px;font-size:14px;color:#303133;">
            <span>{{ $t('order.parcel.totalWeight') }}：<b style="color:#409EFF;font-size:16px;">{{ totalCargoWeight }} {{ weightUnitText }}</b></span>
            <span>{{ $t('order.parcel.totalVolumeWeight') }}：<b style="color:#409EFF;font-size:16px;">{{ totalVolumeWeight }} {{ weightUnitText }}</b></span>
          </div>
        </el-col>
      </el-row>
      <!-- 申报项目 -->
      <el-row :gutter="10" class="border-col">
        <el-col :span="24" style="display: flex">
          <div class="place-title" style="display: flex">{{ $t('order.fplace.title.declaredItems') }}</div>
          <div class="parcel-top">
            <i
              style="font-size: 20px; color: #409dfe; cursor: pointer"
              class="el-icon-circle-plus-outline"
              @click.stop="addProject"
            ></i>
          </div>
        </el-col>
      </el-row>
      <!-- 包装内容 / 包装内容选项：整个国际单共用一份总设置，不再在每个申报项目行中重复 -->
      <div class="parcel-item1 parcel-pack-global">
        <el-row :gutter="10">
          <el-col :span="4">
            <div class="parcel-item-label">{{ $t('order.fplace.label.packageContent') }}</div>
            <el-form-item label="" label-width="0px" prop="type_pack" :rules="rules.type_pack">
              <el-radio-group v-model="ruleForm.type_pack" @change="changeTypePack">
                <el-radio :label="$t('order.fplace.options.packageContent.item')"></el-radio>
                <el-radio :label="$t('order.fplace.options.packageContent.document')"></el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <div class="parcel-item-label">{{ $t('order.fplace.label.packageContentOption') }}</div>
            <el-form-item label="" label-width="0px" prop="type_content" :rules="rules.type_content">
              <div class="parcel-lwh">
                <el-select
                  filterable
                  v-model="ruleForm.type_content"
                  :placeholder="$t('order.fplace.placeholder.selectContentOption')"
                  style="width: 300px"
                >
                  <el-option
                    v-for="(opt, optIdx) in typePack[ruleForm.type_pack]"
                    :key="optIdx"
                    :label="opt.name"
                    :value="opt.name"
                  ></el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="parcel-item1" v-for="(item, index) in ruleForm.project_list" :key="index + 1">
        <el-row :gutter="10">
          <el-col :span="4">
            <div class="parcel-item-label">{{ $t('order.fplace.label.customsCode') }}</div>
            <el-form-item label="" label-width="0px" :prop="`project_list[${index}][code]`">
              <el-input v-model="item.code" placeholder="6-10 位 HS Code" maxlength="10"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <div class="parcel-item-label">{{ $t('order.fplace.label.unitOfMeasure') }}</div>
            <el-form-item
              label=""
              label-width="0px"
              :prop="`project_list[${index}][unit_of]`"
              :rules="rules.unit_of"
            >
              <el-select
                v-model="item.unit_of"
                filterable
                :placeholder="$t('order.fplace.placeholder.selectUnit')"
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in unitList"
                  :key="index"
                  :label="item.label"
                  :value="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <div class="parcel-item-label">{{ $t('order.fplace.label.productValue') }}</div>
            <el-form-item
              label=""
              label-width="0px"
              :prop="`project_list[${index}][unit_price]`"
              :rules="rules.unit_price"
            >
              <div class="parcel-lwh">
                <el-input v-model="item.unit_price" :step="1" style="width: 180px"></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <div class="parcel-item-label">{{ $t('order.fplace.label.productDescription') }}</div>
            <el-form-item
              label=""
              label-width="0px"
              :prop="`project_list[${index}][product_info]`"
              :rules="rules.product_info"
            >
              <div class="parcel-lwh">
                <el-input v-model="item.product_info" :step="1" style="width: 100%"></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <div class="parcel-item-label">{{ $t('order.fplace.label.quantity') }}</div>
            <el-form-item
              label=""
              label-width="0px"
              :prop="`project_list[${index}][num]`"
              :rules="rules.num"
            >
              <div class="parcel-lwh">
                <el-input v-model="item.num" :step="1" style="width: 180px"></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <div class="parcel-item-label">{{ $t('order.fplace.label.netWeight') }}</div>
            <el-form-item
              label=""
              label-width="0px"
              :prop="`project_list[${index}][suttle]`"
              :rules="rules.suttle"
            >
              <div class="parcel-lwh">
                <el-input v-model="item.suttle" :step="1" style="width: 180px"></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <div class="parcel-item-label">{{ $t('order.fplace.label.origin') }}</div>
            <el-form-item
              label=""
              label-width="0px"
              :prop="`project_list[${index}][chandi]`"
              :rules="rules.chandi"
            >
              <div class="parcel-lwh">
                <el-select
                  filterable
                  v-model="item.chandi"
                  :placeholder="$t('order.fplace.placeholder.selectOrigin')"
                  style="width: 180px"
                >
                  <el-option
                    v-for="(item, index) in countryList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="1" v-if="ruleForm.project_list.length > 1">
            <i
              style="font-size: 20px; color: #f56c6c; cursor: pointer; margin-right: 10px"
              class="el-icon-delete"
              @click.stop="delProject(index)"
            ></i>
          </el-col>
        </el-row>
      </div>

      <!-- 按钮 -->
      <el-row :gutter="10">
        <el-col :span="24" class="bttn">
          <el-button
            type="warning"
            size="small"
            @click="handleFree('ruleForm')"
            :loading="freeLoading"
            >{{ $t('order.fplace.button.predictRate') }}</el-button
          >
          <div class="free-rate" v-if="ratesMoney">
            {{ $t('order.fplace.label.productValue') }}：<span>{{ $t('order.fplace.unit.currency') }}{{ ratesMoney.toFixed(2) }} {{ $t('order.fplace.label.weight') }}：{{ ratesWeight }}</span>
          </div>
          <el-button
            type="success"
            size="small"
            @click="submitDraftForm('ruleForm')"
            :loading="draftLoading"
            >{{ $t('order.fplace.button.saveDraft') }}</el-button
          >
          <el-button type="primary" size="small" @click="openImmediatePay('ruleForm')" :loading="orderLoading">{{ $t('recharge.payCreateShipment') }}</el-button>
          <el-button
            type="primary"
            size="small"
            @click="storeForm('ruleForm')"
            :loading="storeLoading"
            >{{ $t('order.fplace.button.storeShipment') }}</el-button
          >
          <el-button @click="resetForm('ruleForm')" size="small">{{ $t('order.fplace.button.reset') }}</el-button>
        </el-col>
      </el-row>
    </el-form>
    <OrderPayDialog :visible.sync="payVisible" :amount="ratesMoney" @success="onImmediatePaySuccess" />
    <!-- 面单 -->
        <RateProgress ref="rateProgress" :visible.sync="rateProgressVisible" streamType="international" @stream-complete="onRateStreamComplete" @stream-error="onRateStreamError" @stream-abort="onRateStreamAbort" />
        <el-dialog
      :close-on-click-modal="false"
      :title="$t('order.fplace.dialog.predictCost')"
      append-to-body
      :visible.sync="freeVisible"
      width="1300px"
      :before-close="closeFreeDialog"
    >
      <Free v-if="freeVisible" :freeInfo="freeInfo" append-to-body @getRatesInfo="getRatesInfo" />
    </el-dialog>
    <!-- 校验地址后的提示 -->
        <el-dialog
      :close-on-click-modal="false"
      :title="$t('order.fplace.dialog.verifyResult')"
      append-to-body
      :visible.sync="checkVisible"
      width="400px"
      class="check-dialog"
      :before-close="closeCheckDialog"
    >
      <Check v-if="checkVisible" append-to-body @closeCheck="closeCheck" :checkInfo="checkInfo" />
    </el-dialog>
    <!-- 解析地址 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="$t('order.fplace.resolution.jiexidizhi')"
      append-to-body
      :visible.sync="resoluVisible"
      width="900px"
    >
      <AddressResolution v-if="resoluVisible" :resoluNum="resoluNum" append-to-body @resoluResult="resoluResult" />
    </el-dialog>
  </div>
</template>

<script>
import { address, addressAdd } from "@/api/address";
import {
  createorder_new,
  fbaList,
  rates_new,
  orderInfo,
  saveOrder_new,
  cityInfo,
  storeOrder_new,
} from "@/api/order";
import { fCity, serviceNameList, checkAddress, serviceListnew } from "@/api/common";
import Free from "./components/free.vue";
import Check from "./components/check.vue";
import RateProgress from "./components/rateProgress.vue";
import OrderPayDialog from "./components/orderPayDialog.vue";
import AddressResolution from "./components/addressResolution.vue";
import {
  validatenull,
  transformCountryCity,
  provinceListValue,
  findTimeIndex,
  normalizeAddressOverflow,
  formatPickupDateValue,
  isPickupDateBeforeToday,
} from "@/common/common.js";
export default {
  components: {
    Free,
    Check,
    RateProgress,
    AddressResolution,
    OrderPayDialog
  },
  props: {
    record: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      resoluNum: 0,
      resoluVisible: false,
      sendSelectValue: [],
      receiveSelectValue: [],
      pa_unit: this.$t('order.fplace.unit.lbIn'),
      FbaValue: "",
      freeVisible: false,
      freeInfo: {},
      checkVisible: false,
      checkInfo: {},
      ratesMoney: "",
      ratesWeight: "",
      freeLoading: false,
      rateProgressVisible: false,
      draftLoading: false,
      orderLoading: false,
      payVisible: false,
      storeLoading: false,
      pa_type_list: [
        { label: "Your 10kg Box" },
        { label: "Your 25kg Box" },
        { label: "Your Envelope" },
        { label: "Your Extra Large Box" },
        { label: "Your Large Box" },
        { label: "Your Medium Box" },
        { label: "Your Pak" },
        { label: "Your Small Box" },
        { label: "Your Tube" },
        { label: "Your Packaging" },
      ],
      qtimelist: [
        "7:00 am", "7:30 am", "8:00 am", "8:30 am", "9:00 am", "9:30 am", "10:00 am", "10:30 am",
        "11:00 am", "11:30 am", "12:00 pm", "12:30 pm", "1:00 pm", "1:30 pm", "2:00 pm", "2:30 pm",
        "3:00 pm", "3:30 pm", "4:00 pm", "4:30 pm", "5:00 pm", "5:30 pm", "6:00 pm", "6:30 pm",
        "7:00 pm", "7:30 pm", "8:00 pm", "8:30 pm", "9:00 pm",
      ],
      qendtimelist: [],
      ruleForm: {
        goods_info: {
          is_sign: 0,
          service_type: "",
          USPSEndorsement: 1,
          booking_confirmation_number: "",
        },
        // 包装内容 / 包装内容选项：整个国际单共用一份总设置（不再逐申报项目单独填）
        // 提交前会由顶层分发写回 project_list 每一行，保持后端接口字段结构不变
        type_pack: this.$t('order.fplace.options.packageContent.item'),
        type_content: this.$t('order.fplace.options.itemTypes.commercial'),
        package_list: [
          {
            Sku: "001",
            insurance: 0,
            itemQty: 1,
            pa_height: '',
            pa_lb: "",
            pa_length: '',
            pa_num: 1,
            pa_type: "Your Packaging",
            pa_width: '',
          },
        ],
        project_list: [
          {
            code: "",
            unit_of: "",
            unit_price: "",
            product_info: "",
            pack_kind: "",
            num: "",
            suttle: "",
            chandi: "",
          },
        ],
        receive_data: {
          company: "",
          address_two: "",
          address_three: "",
          email: "",
          country: "United States",
        },
        send_data: {
          company: "",
          address_two: "",
          address_three: "",
          email: "",
          country: "United States",
        },
        is_qu: 0,
        q_data: {
          company: "",
          address_two: "",
        },
        q_package: {},
      },
      is_qus: false,
      countryList: [],
      sendProvinceList: [],
      receiveProvinceList: [],
      qProvinceList: [],
      channelList: [],
      serviceTypeMap: {},
      fbaLists: [],
      receive_list: [],
      send_list: [],
      send_oneself_list: [
        {
          name: "CTSGCOCA",
          addr: {
            address_one: "2300 S EASTERN AVE",
            city: "Commerce",
            company: "Operation Manager",
            country: "United States",
            email: "jessiew@ctsglobalsolutions.com",
            mobile: "(626) 693-8893",
            province: "CA",
            realname: "Jessie Wang",
            zcode: "90040-1431",
          },
        },
        {
          name: "CTSGSGNY",
          addr: {
            address_one: "14709 182ND ST",
            city: "Springfield Gardens",
            company: "Operation Manager",
            country: "United States",
            email: "ront@ctsglobalsolutions.com",
            mobile: "(626) 709-3199",
            province: "NY",
            realname: "Ron Tong",
            zcode: "11413-4034",
          },
        },
      ],
      id: "",
      unitList: [
        { label: "Most used" }, { label: "pieces" }, { label: "each" }, { label: "box" },
        { label: "number" }, { label: "no unit required" }, { label: "Basic" }, { label: "barrels" },
        { label: "crate" }, { label: "dose" }, { label: "dozen" }, { label: "dozen pairs" },
        { label: "dozen pieces" }, { label: "gross" }, { label: "hundred" }, { label: "items" },
        { label: "leaf" }, { label: "one hundred leaves" }, { label: "pack (cards)" }, { label: "packs" },
        { label: "pair" }, { label: "rolls" }, { label: "running bales" }, { label: "sets" },
        { label: "square" }, { label: "thousand" }, { label: "units" }, { label: "yarn" },
        { label: "Imperial" }, { label: "ounces" }, { label: "pounds" }, { label: "short tons" },
        { label: "feet" }, { label: "yards" }, { label: "linear feet" }, { label: "linear yards" },
        { label: "square inches" }, { label: "square feet" }, { label: "square yards" },
        { label: "hundred square inches" }, { label: "board feet" }, { label: "gallon" },
        { label: "cubic feet" }, { label: "cubic yards" }, { label: "Minerals and gemstones" },
        { label: "carats" }, { label: "jewels" }, { label: "quarts" },
      ],
      typePack: {
        [this.$t('order.fplace.options.packageContent.item')]: [
          {name: this.$t('order.fplace.options.itemTypes.commercial')},
          {name: this.$t('order.fplace.options.itemTypes.gift')},
          {name: this.$t('order.fplace.options.itemTypes.sample')},
          {name: this.$t('order.fplace.options.itemTypes.repairReturn')},
          {name: this.$t('order.fplace.options.itemTypes.personalEffects')},
          {name: this.$t('order.fplace.options.itemTypes.personalUse')}
        ],
        [this.$t('order.fplace.options.packageContent.document')]: [
          {name: this.$t('order.fplace.options.documentTypes.personal')},
          {name: this.$t('order.fplace.options.documentTypes.interoffice')},
          {name: this.$t('order.fplace.options.documentTypes.business')},
          {name: this.$t('order.fplace.options.documentTypes.other')}
        ]
      }
    };
  },
  computed: {
    pickupDatePickerOptions() {
      return {
        disabledDate: (time) => isPickupDateBeforeToday(
          time,
          this.ruleForm.q_data.country,
          this.ruleForm.q_data.province,
        ),
      };
    },
    rules() {
      return {
        "send_data.realname": [{ required: true, message: this.$t('order.fplace.validation.enterShipperName'), trigger: "blur" }],
        "send_data.country": [{ required: true, message: this.$t('order.fplace.validation.selectShipperCountry'), trigger: "change" }],
        "send_data.province": [{ required: true, message: this.$t('order.fplace.validation.selectShipperState'), trigger: "change" }],
        "send_data.city": [{ required: true, message: this.$t('order.fplace.validation.enterShipperCity'), trigger: "blur" }],
        "send_data.zcode": [{ required: true, message: this.$t('order.fplace.validation.enterShipperZip'), trigger: "blur" }],
        "send_data.address_one": [{ required: true, message: this.$t('order.fplace.validation.enterShipperAddress'), trigger: "blur" }],
        "send_data.mobile": [{ required: true, message: this.$t('order.fplace.validation.enterShipperPhone'), trigger: "blur" }],

        "receive_data.realname": [{ required: true, message: this.$t('order.fplace.validation.enterConsigneeName'), trigger: "blur" }],
        "receive_data.country": [{ required: true, message: this.$t('order.fplace.validation.selectConsigneeCountry'), trigger: "change" }],
        "receive_data.province": [{ required: true, message: this.$t('order.fplace.validation.selectConsigneeState'), trigger: "change" }],
        "receive_data.city": [{ required: true, message: this.$t('order.fplace.validation.enterConsigneeCity'), trigger: "blur" }],
        "receive_data.zcode": [{ required: true, message: this.$t('order.fplace.validation.enterConsigneeZip'), trigger: "blur" }],
        "receive_data.address_one": [{ required: true, message: this.$t('order.fplace.validation.enterConsigneeAddress'), trigger: "blur" }],
        "receive_data.mobile": [{ required: true, message: this.$t('order.fplace.validation.enterConsigneePhone'), trigger: "blur" }],

        "goods_info.pservice_type": [{ required: true, message: this.$t('order.fplace.validation.selectLogisticsChannel'), trigger: "change" }],

        "q_data.realname": [{ required: true, message: this.$t('order.fplace.validation.enterPickupName'), trigger: "blur" }],
        "q_data.country": [{ required: true, message: this.$t('order.fplace.validation.selectPickupCountry'), trigger: "change" }],
        "q_data.province": [{ required: true, message: this.$t('order.fplace.validation.selectPickupState'), trigger: "change" }],
        "q_data.city": [{ required: true, message: this.$t('order.fplace.validation.enterPickupCity'), trigger: "blur" }],
        "q_data.zcode": [{ required: true, message: this.$t('order.fplace.validation.enterPickupZip'), trigger: "blur" }],
        "q_data.address_one": [{ required: true, message: this.$t('order.fplace.validation.enterPickupAddress'), trigger: "blur" }],
        "q_data.mobile": [{ required: true, message: this.$t('order.fplace.validation.enterPickupPhone'), trigger: "blur" }],
        
        "q_package.package_all_num": [{ required: true, message: this.$t('order.fplace.validation.enterTotalPackages'), trigger: "blur" }],
        "q_package.all_weight": [{ required: true, message: this.$t('order.fplace.validation.enterTotalWeight'), trigger: "blur" }],
        "q_package.q_date": [{ required: true, message: this.$t('order.fplace.validation.selectPickupDate'), trigger: "change" }],
        "q_package.q_time": [{ required: true, message: this.$t('order.fplace.validation.selectReadyTime'), trigger: "change" }],
        "q_package.q_endtime": [{ required: true, message: this.$t('order.fplace.validation.selectLatestTime'), trigger: "change" }],

        code: [
          { required: true, message: this.$t('order.fplace.validation.enterCustomsCode'), trigger: "blur" },
          { pattern: /^\d{6,10}$/, message: this.$t('order.fplace.validation.customsCodeFormat') || '海关编码请输入 6-10 位数字（HS Code）', trigger: 'blur' }
        ],
        unit_of: [{ required: true, message: this.$t('order.fplace.validation.enterUnit'), trigger: "blur" }],
        unit_price: [{ required: true, message: this.$t('order.fplace.validation.enterProductValue'), trigger: "blur" }],
        product_info: [{ required: true, message: this.$t('order.fplace.validation.enterProductDescription'), trigger: "blur" }],
        pack_kind: [{ required: true, message: this.$t('order.fplace.validation.enterPackageKind'), trigger: "blur" }],
        num: [{ required: true, message: this.$t('order.fplace.validation.enterQuantity'), trigger: "blur" }],
        suttle: [{ required: true, message: this.$t('order.fplace.validation.enterNetWeight'), trigger: "blur" }],
        chandi: [{ required: true, message: this.$t('order.fplace.validation.enterOrigin'), trigger: "blur" }],
        type_pack: [{ required: true, message: this.$t('order.fplace.validation.selectPackageContent'), trigger: "change" }],
        type_content: [{ required: true, message: this.$t('order.fplace.validation.selectContentOption'), trigger: "change" }],

        Sku: [{ required: true, message: this.$t('order.fplace.validation.enterSku'), trigger: "blur" }],
        pa_num: [{ required: true, message: this.$t('order.fplace.validation.enterPackageQuantity'), trigger: "blur" }],
        pa_lb: [{ required: true, message: this.$t('order.fplace.validation.enterWeight'), trigger: "blur" }],
        pa_length: [{
          required: true,
          validator: (rule, value, callback) => {
            // 从 prop 路径解析当前包裹的 index
            const match = rule.field.match(/package_list\[(\d+)\]/);
            if (!match) return callback();
            const idx = parseInt(match[1]);
            const pkg = this.ruleForm.package_list[idx];
            if (!pkg) return callback();
            const l = parseFloat(pkg.pa_length);
            const w = parseFloat(pkg.pa_width);
            const h = parseFloat(pkg.pa_height);
            if (!l || l <= 0) return callback(new Error(this.$t('order.fplace.validation.enterDimensions') || '请填写长度'));
            if (!w || w <= 0) return callback(new Error(this.$t('order.fplace.validation.enterDimensions') || '请填写宽度'));
            if (!h || h <= 0) return callback(new Error(this.$t('order.fplace.validation.enterDimensions') || '请填写高度'));
            callback();
          },
          trigger: "blur"
        }],
      }
    },
    // 当前是否为英制单位(磅/英寸)，与模板尺寸/重量单位判断保持一致
    isImperial() {
      return this.pa_unit == this.$t('order.fplace.unit.lbIn') || this.pa_unit == '磅/英寸' || this.pa_unit == 'lb/in'
    },
    // 当前重量单位文案：英制显示 lb，公制显示 kg
    weightUnitText() {
      return this.isImperial ? this.$t('order.fplace.unit.lb') : this.$t('order.fplace.unit.kg')
    },
    // 总重量 = Σ(单件重量 pa_lb × 包裹数量 pa_num)，保留2位小数；口径与后端测价一致
    totalCargoWeight() {
      const sum = (this.ruleForm.package_list || []).reduce((acc, item) => {
        const lb = parseFloat(item.pa_lb) || 0
        const num = parseInt(item.pa_num) || 0
        return acc + lb * num
      }, 0)
      return sum.toFixed(2)
    },
    // 总体积重量 = Σ(长×宽×高 ÷ 系数 × 包裹数量)。英寸÷139得体积磅，厘米÷5000得体积千克
    totalVolumeWeight() {
      const divisor = this.isImperial ? 139 : 5000
      const sum = (this.ruleForm.package_list || []).reduce((acc, item) => {
        const l = parseFloat(item.pa_length) || 0
        const w = parseFloat(item.pa_width) || 0
        const h = parseFloat(item.pa_height) || 0
        const num = parseInt(item.pa_num) || 0
        return acc + (l * w * h / divisor) * num
      }, 0)
      return sum.toFixed(2)
    }
  },
  mounted() {
    if (!validatenull(this.record)) {
      this.id = this.record.order_id;
      this.getOrderInfo();
    }
  },
  watch: {
    // countryList 加载完成后，补一次产地白名单清洗（覆盖 getOrderInfo 比 getCity 先返回的情况）
    countryList(newList) {
      if (Array.isArray(newList) && newList.length > 0) {
        this.cleanProjectListOrigin();
      }
    }
  },
  created() {
    this.getFbaList();
    this.getCity();
    this.getServiceNameList();
    this.getAddress();
    if (this.$route.query.form) {
      let form = JSON.parse(this.$route.query.form);
      this.ruleForm.send_data.zcode = form.start_zip_code;
      this.ruleForm.send_data.country = form.start_country;
      this.ruleForm.receive_data.zcode = form.destination_zip_code;
      this.ruleForm.receive_data.country = form.destination_country;
      this.ruleForm.send_data.province = "CA";
      this.ruleForm.send_data.province = form.send_data_province;
      this.ruleForm.send_data.city = form.send_data_city;
      this.sendProvinceList = provinceListValue(this.countryList, this.ruleForm.send_data.country || "United States");
      this.ruleForm.receive_data.province = form.receive_data_province;
      this.ruleForm.receive_data.city = form.receive_data_city;
      this.receiveProvinceList = provinceListValue(this.countryList, this.ruleForm.receive_data.country || "United States");
      this.pa_unit = form.pa_unit == "lb/in" ? this.$t('order.fplace.unit.lbIn') : this.$t('order.fplace.unit.kgCm');
      let package_list = [];
      package_list.push({
        Sku: "001",
        insurance: 0,
        itemQty: form.itemQty,
        pa_height: form.pa_height,
        pa_lb: form.pa_lb,
        pa_length: form.pa_length,
        pa_num: form.pack_num,
        pa_type: "Your Packaging",
        pa_width: form.pa_width,
      });
      this.ruleForm.package_list = package_list;
      let project_list = [];
      project_list.push({
        code: form.code,
        unit_of: form.unit_of,
        unit_price: form.unit_price,
        product_info: form.product_info,
        pack_kind: form.pack_kind,
        num: form.num,
        suttle: form.suttle,
        chandi: form.chandi,
      });
      this.ruleForm.project_list = project_list;
      // 包装内容 / 包装内容选项 提到顶层，兼容 AI 测价页跳转带过来的老字段
      if (form.type_pack) this.ruleForm.type_pack = form.type_pack;
      if (form.type_content) this.ruleForm.type_content = form.type_content;
    }
  },
  methods: {
    // 解析地址弹窗
    handleResolution(num){
      this.resoluVisible = true
      this.resoluNum = num
    },
    // 解析结果
    resoluResult(num,obj){
      if(num == 1){
        if (obj) {
          this.ruleForm.send_data = { ...obj, province: obj.province.split("-")[0] };
          this.sendProvinceList = provinceListValue(this.countryList, obj.country);
          if (this.is_qus) this.fillPickupFromSender();
        }
      }else if(num == 2){
        if (obj) {
          this.ruleForm.receive_data = { ...obj, province: obj.province.split("-")[0] };
          this.receiveProvinceList = provinceListValue(this.countryList, obj.country);
          this.FbaValue = [];
        }
      }

      this.resoluVisible = false
      this.resoluNum = 0
    },
    // 包装内容切换：现在是整单一份的总设置（顶层 ruleForm.type_pack），
    // 切换 项目 / 文件 时联动重置 type_content 到对应分组默认值，防止残留旧值
    changeTypePack() {
      const itemLabel = this.$t('order.fplace.options.packageContent.item');
      const defaultItem = this.$t('order.fplace.options.itemTypes.commercial');
      const defaultDoc = this.$t('order.fplace.options.documentTypes.personal');
      this.ruleForm.type_content = this.ruleForm.type_pack == itemLabel ? defaultItem : defaultDoc;
    },
    // 兼容订单详情里历史数据的包装内容写法，保证与当前语言下 radio 的 label 一致
    normalizeTypePackValue(value, content) {
      const itemLabel = this.$t('order.fplace.options.packageContent.item');
      const docLabel = this.$t('order.fplace.options.packageContent.document');
      const raw = String(value || '').trim();
      const upper = raw.toUpperCase();
      if (raw === docLabel || raw === '文件' || upper === 'DOCUMENT') return docLabel;
      if (!raw && content) {
        const normalize = (str) => String(str || '')
          .trim()
          .replace(/\s+/g, ' ')
          .toUpperCase();
        const target = normalize(content);
        const docList = (this.typePack[docLabel] || []).map((item) => normalize(item.name));
        const docShortList = ['PERSONAL', 'INTEROFFICE', 'BUSINESS', 'OTHER'];
        if (docList.includes(target) || docShortList.includes(target)) return docLabel;
      }
      return itemLabel;
    },
    // 兼容历史/移动端内容选项写法，保证与当前下拉选项值一致
    normalizeTypeContentValue(value, typePack) {
      const itemLabel = this.$t('order.fplace.options.packageContent.item');
      const docLabel = this.$t('order.fplace.options.packageContent.document');
      const pack = typePack || itemLabel;
      const list = (this.typePack[pack] || this.typePack[itemLabel] || []).map((item) => item.name);
      const raw = String(value || '').trim();
      if (!raw) return list[0] || '';

      const normalize = (str) => String(str || '')
        .trim()
        .replace(/\s*&\s*/g, ' and ')
        .replace(/\s*\/\s*/g, ' and ')
        .replace(/\s+/g, ' ')
        .toUpperCase();
      const target = normalize(raw);
      const matched = list.find((name) => normalize(name) === target);
      if (matched) return matched;

      if (pack === docLabel) {
        const looseMatched = list.find((name) => normalize(name).indexOf(target) === 0);
        if (looseMatched) return looseMatched;
      }
      return list[0] || '';
    },
    changeTime(e) {
      this.qendtimelist = findTimeIndex(this.qtimelist, e);
    },
    handleCheck(value) {
      this.ruleForm.is_qu = value ? 1 : 0;
      if (value) this.fillPickupFromSender();
    },
    fillPickupFromSender() {
      const sender = this.ruleForm.send_data || {};
      const pickup = { company: "", address_two: "", email: "", ...(this.ruleForm.q_data || {}) };
      ["realname", "company", "country", "province", "city", "zcode", "address_one", "address_two", "mobile", "email"].forEach((key) => {
        pickup[key] = sender[key] || "";
      });
      this.$set(this.ruleForm, "q_data", pickup);
      this.qProvinceList = pickup.country ? provinceListValue(this.countryList, pickup.country) : [];
      this.$nextTick(() => {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate([
            "q_data.realname", "q_data.country", "q_data.province",
            "q_data.city", "q_data.zcode", "q_data.address_one", "q_data.mobile",
          ]);
        }
      });
    },
    clearAddress(num) {
      if (num == 1) {
        this.ruleForm.send_data = { company: "", address_two: "", email: "" };
        this.sendSelectValue = [];
        this.sendProvinceList = [];
        this.$nextTick(() => {
          this.$refs.ruleForm.clearValidate([
            "send_data.realname", "send_data.country", "send_data.province",
            "send_data.city", "send_data.zcode", "send_data.address_one", "send_data.mobile",
          ]);
        });
      } else if (num == 2) {
        this.ruleForm.receive_data = { company: "", address_two: "", email: "" };
        this.FbaValue = "";
        this.receiveProvinceList = [];
        this.receiveSelectValue = [];
        this.$nextTick(() => {
          this.$refs.ruleForm.clearValidate([
            "receive_data.realname", "receive_data.country", "receive_data.province",
            "receive_data.city", "receive_data.zcode", "receive_data.address_one", "receive_data.mobile",
          ]);
        });
      } else if (num == 3) {
        this.ruleForm.q_data = { company: "", address_two: "", email: "" };
        this.qProvinceList = [];
        this.$nextTick(() => {
          this.$refs.ruleForm.clearValidate([
            "q_data.realname", "q_data.country", "q_data.province",
            "q_data.city", "q_data.zcode", "q_data.address_one", "q_data.mobile",
          ]);
        });
      }
    },
    swapAddress() {
      const tempSend = JSON.parse(JSON.stringify(this.ruleForm.send_data));
      const tempReceive = JSON.parse(JSON.stringify(this.ruleForm.receive_data));
      const tempSendProvince = this.sendProvinceList;
      const tempReceiveProvince = this.receiveProvinceList;

      this.ruleForm.send_data = tempReceive;
      this.ruleForm.receive_data = tempSend;
      this.sendProvinceList = tempReceiveProvince;
      this.receiveProvinceList = tempSendProvince;

      this.sendSelectValue = '';
      this.receiveSelectValue = '';
      this.FbaValue = '';
      if (this.is_qus) this.fillPickupFromSender();

      this.$message.success('发件人和收件人地址已交换');
    },
    // 产地白名单清洗：把 ruleForm.project_list 中不在 countryList 内的 chandi 置空。
    // countryList 未加载（length=0）时不清洗，避免误清空（watch 会在加载完成后回调再清洗一次）。
    cleanProjectListOrigin() {
      if (!this.ruleForm || !Array.isArray(this.ruleForm.project_list)) return;
      if (!Array.isArray(this.countryList) || this.countryList.length === 0) return;
      // 与产地下拉 el-option 的 :value="item.value" 对齐，用 value 作为合法产地集合
      const validOrigins = this.countryList.map((c) => c.value);
      this.ruleForm.project_list.forEach((item) => {
        if (item && item.chandi && !validOrigins.includes(item.chandi)) {
          item.chandi = '';
        }
      });
    },
    getOrderInfo() {
      orderInfo({
        user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
        order_id: this.id,
      }).then((res) => {
        if (res.code == 1) {
          let forms = normalizeAddressOverflow(res.data);
          forms.receive_data.province = forms.receive_data.province.split("-")[0];
          forms.send_data.province = forms.send_data.province.split("-")[0];
          if (forms.q_data.province) {
            forms.q_data.province = forms.q_data.province.split("-")[0];
          }
          if (forms.q_package && forms.q_package.q_date) {
            forms.q_package.q_date = formatPickupDateValue(forms.q_package.q_date);
          }
          // 包装内容 / 包装内容选项：顶层字段兼容处理
          // 老订单每行都带 type_pack / type_content，接手后统一提到 ruleForm 顶层展示
          // 未来所有新订单顶层直接就有这两个字段
          const firstProject = Array.isArray(forms.project_list) && forms.project_list[0] ? forms.project_list[0] : null;
          const rawTypeContent = forms.type_content || (firstProject && firstProject.type_content);
          forms.type_pack = this.normalizeTypePackValue(forms.type_pack || (firstProject && firstProject.type_pack), rawTypeContent);
          forms.type_content = this.normalizeTypeContentValue(rawTypeContent, forms.type_pack);
          this.ruleForm = forms;
          // 产地白名单清洗：已有订单中 chandi 若不在国家下拉列表里（脏数据 / AI 旧版本默认值），
          // 必须置空让用户重新选，避免下拉显示一个不在选项里的值（视觉上像被选中）。
          // 此处先尝试清洗一次；若 countryList 此时尚未加载完成，watch 监听会在加载完成后再补一次。
          this.cleanProjectListOrigin();
          this.sendProvinceList = provinceListValue(this.countryList, forms.send_data.country);
          this.receiveProvinceList = provinceListValue(this.countryList, forms.receive_data.country);
          if (forms.q_data.country) {
            this.qProvinceList = provinceListValue(this.countryList, forms.q_data.country);
          }
          if (forms.q_package.q_time) {
            this.qendtimelist = findTimeIndex(this.qtimelist, forms.q_package.q_time);
          }
          this.is_qus = forms.is_qu == 1 ? true : false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    addAddress(formName, num) {
      var sendValidate = [
        "send_data.realname", "send_data.country", "send_data.province",
        "send_data.city", "send_data.zcode", "send_data.address_one", "send_data.mobile",
      ];
      var receiveValidate = [
        "receive_data.realname", "receive_data.country", "receive_data.province",
        "receive_data.city", "receive_data.zcode", "receive_data.address_one", "receive_data.mobile",
      ];
      var validList = num == 1 ? sendValidate : receiveValidate;
      var allValid = true;
      validList.forEach((field) => {
        this.$refs[formName].validateField(field, (errorMessage) => {
          if (errorMessage) allValid = false;
        });
      });
      if (allValid) {
        if (num == 1) {
          addressAdd({
            user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
            user_type: 1,
            ...this.ruleForm.send_data,
          }).then((res) => {
            if (res.code == 1) {
              this.$message.success(res.msg);
            } else {
              this.$message.error(res.msg);
            }
          }).catch((err) => {
            this.$message.error(err.msg);
          });
        } else if (num == 2) {
          addressAdd({
            user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
            user_type: 2,
            ...this.ruleForm.receive_data,
          }).then((res) => {
            if (res.code == 1) {
              this.$message.success(res.msg);
            } else {
              this.$message.error(res.msg);
            }
          }).catch((err) => {
            this.$message.error(err.msg);
          });
        } else {
          checkAddress({
            user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
            receive_data: {
              ...this.ruleForm.receive_data,
              province: this.ruleForm.receive_data.province.split("-")[0],
            },
          }).then((res) => {
            if (res.code == 1) {
              this.checkVisible = true;
              this.checkInfo = res.data;
            } else {
              this.$message.error(res.msg);
            }
          }).catch((err) => {
            this.$message.error(err.msg);
          });
        }
      }
    },
    closeCheckDialog() {
      this.checkVisible = false;
      this.checkInfo = {};
    },
    closeCheck() {
      this.checkVisible = false;
      this.checkInfo = {};
    },
    getAddress() {
      address({
        user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
        page: 0,
      }).then((res) => {
        if (res.code == 1) {
          res.data.list.forEach((item) => {
            item.user_type == 1 ? this.send_list.push(item) : this.receive_list.push(item);
          });
        }
      });
    },
    getFbaList() {
      fbaList({
        user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
      }).then((res) => {
        this.fbaLists = res.data;
      });
    },
    getServiceNameList() {
      serviceListnew({
        user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
      }).then((res) => {
        this.channelList = res.data.map((item) => {
          return { name: item };
        });
        // 构建服务名称到服务商的映射，用于选择物流渠道时自动设置 service_type
        if (res.pservice_type) {
          const map = {};
          Object.keys(res.pservice_type).forEach((sType) => {
            (res.pservice_type[sType] || []).forEach((sName) => {
              map[sName] = sType;
            });
          });
          this.serviceTypeMap = map;
        }
      });
    },
    getCity() {
      fCity().then((res) => {
        this.countryList = transformCountryCity(res.data);
        this.sendProvinceList = provinceListValue(this.countryList, this.ruleForm.send_data.country || "United States");
        this.receiveProvinceList = provinceListValue(this.countryList, this.ruleForm.receive_data.country || "United States");
      });
    },
    getCityInfo(num) {
      const target = num == 1 ? this.ruleForm.send_data : num == 2 ? this.ruleForm.receive_data : this.ruleForm.q_data;
      if (target.country === "Panama" && /^\d{1,4}$/.test(target.zcode || "")) {
        target.zcode = String(target.zcode).padStart(5, "0");
      }
      if (target.country !== "United States") return;
      let zcode = target.zcode;
      cityInfo({ zcode }).then((res) => {
        if (res.code == 1) {
          if (num == 1) {
            this.ruleForm.send_data.country = "United States";
            this.$set(this.ruleForm.send_data, "province", res.data.province);
            this.$set(this.ruleForm.send_data, "city", res.data.city);
            this.sendProvinceList = provinceListValue(this.countryList, "United States");
          } else if (num == 2) {
            this.ruleForm.receive_data.country = "United States";
            this.$set(this.ruleForm.receive_data, "province", res.data.province);
            this.$set(this.ruleForm.receive_data, "city", res.data.city);
            this.receiveProvinceList = provinceListValue(this.countryList, "United States");
          } else if (num == 3) {
            this.ruleForm.q_data.country = "United States";
            this.$set(this.ruleForm.q_data, "province", res.data.province);
            this.$set(this.ruleForm.q_data, "city", res.data.city);
            this.qProvinceList = provinceListValue(this.countryList, "United States");
          }
        }
      });
    },
    handleSendChange(value) {
      this.sendProvinceList = provinceListValue(this.countryList, value);
      delete this.ruleForm.send_data.province;
    },
    handleReceiveChange(value) {
      this.receiveProvinceList = provinceListValue(this.countryList, value);
      delete this.ruleForm.receive_data.province;
    },
    handleQChange(value) {
      this.qProvinceList = provinceListValue(this.countryList, value);
      delete this.ruleForm.q_data.province;
    },
    normalizePickupDate(form) {
      if (form && form.q_package && form.q_package.q_date) {
        form.q_package = { ...form.q_package, q_date: formatPickupDateValue(form.q_package.q_date) };
      }
      return form;
    },
    handleFree(formName) {
      var validList = [
        "send_data.realname", "send_data.country", "send_data.province", "send_data.city",
        "send_data.zcode", "send_data.address_one", "send_data.mobile",
        "receive_data.realname", "receive_data.country", "receive_data.province", "receive_data.city",
        "receive_data.zcode", "receive_data.address_one", "receive_data.mobile",
      ];
      var qlist = [
        "q_data.realname", "q_data.country", "q_data.province", "q_data.city",
        "q_data.zcode", "q_data.address_one", "q_data.mobile",
        "q_package.package_all_num", "q_package.all_weight",
        "q_package.q_date", "q_package.q_time", "q_package.q_endtime",
      ];
      if (this.is_qus) validList = validList.concat(qlist);
      this.ruleForm.package_list.forEach((item, index) => {
        validList.push(`package_list[${index}][Sku]`);
        validList.push(`package_list[${index}][pa_num]`);
        validList.push(`package_list[${index}][pa_length]`);
        validList.push(`package_list[${index}][pa_lb]`);
      });
      this.ruleForm.project_list.forEach((item, index) => {
        validList.push(`project_list[${index}][code]`);
        validList.push(`project_list[${index}][unit_of]`);
        validList.push(`project_list[${index}][unit_price]`);
        validList.push(`project_list[${index}][product_info]`);
        validList.push(`project_list[${index}][pack_kind]`);
        validList.push(`project_list[${index}][num]`);
        validList.push(`project_list[${index}][suttle]`);
        validList.push(`project_list[${index}][chandi]`);
      });
      // 包装内容 / 包装内容选项：整单一份，走顶层字段校验
      validList.push('type_pack');
      validList.push('type_content');
      var allValid = true;
      validList.forEach((field) => {
        this.$refs[formName].validateField(field, (errorMessage) => {
          if (errorMessage) allValid = false;
        });
      });
      if (allValid) {
        let form = {
          ...this.ruleForm,
          user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
        };
        form = this.normalizePickupDate(form);
        let package_list = form.package_list.map((item) => {
          let pa_unit = this.pa_unit == this.$t('order.fplace.unit.lbIn') ? 1 : 2;
          return {
            ...item,
            pa_unit,
            pa_type: "",
            pa_height: parseFloat(item.pa_height) || 1,
            pa_length: parseFloat(item.pa_length) || 1,
            pa_width: parseFloat(item.pa_width) || 1
          };
        });
        form.package_list = package_list;
        // 包装内容 / 包装内容选项：把整单顶层设置分发到 project_list 每一行，保持后端接口结构不变
        form.project_list = (form.project_list || []).map((it) => ({
          ...it,
          type_pack: form.type_pack,
          type_content: form.type_content,
        }));
        form.receive_data.province = form.receive_data.province.split("-")[0];
        form.send_data.province = form.send_data.province.split("-")[0];
        if (form.q_data.province) form.q_data.province = form.q_data.province.split("-")[0];
        if (form.receive_data.remark || form.receive_data.remark == "") delete form.receive_data.remark;
        if (!form.receive_data.email) form.receive_data.email = "";
        if (form.receive_data.id) delete form.receive_data.id;
        if (form.receive_data.user_type) delete form.receive_data.user_type;
        if (form.send_data.remark || form.send_data.remark == "") delete form.send_data.remark;
        if (form.send_data.user_type) delete form.send_data.user_type;
        if (form.send_data.id) delete form.send_data.id;
        if (!form.send_data.email) form.send_data.email = "";
        if (!form.goods_info.hb_order_sn) form.goods_info.hb_order_sn = "";
        delete form.goods_info.order_sn;
        this.freeLoading = true;
        this.rateProgressVisible = true;
        this.$nextTick(() => {
          this.$refs.rateProgress && this.$refs.rateProgress.startStream(form);
        });
      }
    },
    getRatesInfo(info) {
      this.ratesMoney = info.all_money;
      this.ratesWeight = info.weight;
      this.ruleForm.goods_info.service_type = info.service_type;
      this.$set(this.ruleForm.goods_info, "pservice_type", info.service_name);
      this.freeVisible = false;
    },
    closeFreeDialog() {
      this.freeVisible = false;
    },
    onRateStreamComplete(event) {
      this.freeLoading = false;
      if (event.code == 1) {
        this.$message.success(event.msg);
        this.freeInfo = event.data;
        this.freeVisible = true;
      } else {
        this.$message.error(event.msg || this.$t('order.fplace.message.predictFailed'));
      }
    },
    onRateStreamError(err) {
      this.freeLoading = false;
      this.$message.error(err.message || this.$t('order.fplace.message.predictFailed'));
    },
    // 用户主动点叉号取消测价：仅收尾按钮 loading，不弹错误提示
    onRateStreamAbort() {
      this.freeLoading = false;
    },
    selectOneself(obj) {
      this.ruleForm.send_data = { ...obj };
      this.sendProvinceList = provinceListValue(this.countryList, obj.country);
      this.sendSelectValue = [];
      if (this.is_qus) this.fillPickupFromSender();
    },
    changePservice(e) {
      // 根据选择的物流渠道名称自动设置对应的服务商
      this.ruleForm.goods_info.service_type = this.serviceTypeMap[e] || "";
    },
    handlePackageTypeChange(val, index) {
      const sizeMap = {
        'Your 10kg Box': { pa_length: '15.81', pa_width: '12.94', pa_height: '10.19' },
        'Your 25kg Box': { pa_length: '21.56', pa_width: '16.56', pa_height: '13.19' },
        'Your Envelope': { pa_length: '13.19', pa_width: '9.25', pa_height: '' },
        'Your Extra Large Box': { pa_length: '11.88', pa_width: '11', pa_height: '10.75' },
        'Your Large Box': { pa_length: '17.88', pa_width: '12.38', pa_height: '3' },
        'Your Medium Box': { pa_length: '13.25', pa_width: '11.5', pa_height: '2.38' },
        'Your Pak': { pa_length: '14.75', pa_width: '11.75', pa_height: '' },
        'Your Small Box': { pa_length: '12.25', pa_width: '10.9', pa_height: '1.5' },
        'Your Tube': { pa_length: '38', pa_width: '6', pa_height: '6' },
      };
      const size = sizeMap[val];
      if (size) {
        this.$set(this.ruleForm.package_list[index], 'pa_length', size.pa_length);
        this.$set(this.ruleForm.package_list[index], 'pa_width', size.pa_width);
        this.$set(this.ruleForm.package_list[index], 'pa_height', size.pa_height);
      } else {
        this.$set(this.ruleForm.package_list[index], 'pa_length', '');
        this.$set(this.ruleForm.package_list[index], 'pa_width', '');
        this.$set(this.ruleForm.package_list[index], 'pa_height', '');
      }
    },
    selectSendAddr(e) {
      let obj = this.send_list.find((item) => item.id == e);
      if (obj) {
        this.ruleForm.send_data = { ...obj, province: obj.province.split("-")[0] };
        this.sendProvinceList = provinceListValue(this.countryList, obj.country);
        if (this.is_qus) this.fillPickupFromSender();
      }
    },
    selectReceiveAddr(e) {
      let obj = this.receive_list.find((item) => item.id == e);
      if (obj) {
        this.ruleForm.receive_data = { ...obj, province: obj.province.split("-")[0] };
        this.receiveProvinceList = provinceListValue(this.countryList, obj.country);
        this.FbaValue = [];
      }
    },
    selectFBAAddr(e) {
      let obj = this.fbaLists.find((item) => item.id == e);
      if (obj) {
        this.ruleForm.receive_data = { ...obj, province: obj.province.split("-")[0] };
        this.receiveProvinceList = provinceListValue(this.countryList, obj.country);
        this.receiveSelectValue = [];
      }
    },
    openImmediatePay(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        const projectErr = this.validateProjectList(this.ruleForm.project_list);
        if (projectErr) {
          this.$message.error(projectErr);
          return;
        }
        if (!this.ratesMoney || !this.ruleForm.goods_info.pservice_type || !this.ruleForm.goods_info.service_type) {
          this.$message.warning(this.$t('recharge.orderRateRequired'));
          return;
        }
        this.payVisible = true;
      });
    },
    onImmediatePaySuccess() {
      this.submitForm('ruleForm');
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 申报项目严格校验：防止字段错位
          const projectErr = this.validateProjectList(this.ruleForm.project_list);
          if (projectErr) {
            this.$message.error(projectErr);
            return;
          }
          let form = {
            ...this.ruleForm,
            user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
          };
          form = this.normalizePickupDate(form);
          let package_list = form.package_list.map((item) => {
            let pa_unit = this.pa_unit == this.$t('order.fplace.unit.lbIn') ? 1 : 2;
            return {
              ...item,
              pa_unit,
              pa_height: parseFloat(item.pa_height) || 1,
              pa_length: parseFloat(item.pa_length) || 1,
              pa_width: parseFloat(item.pa_width) || 1
            };
          });
          form.package_list = package_list;
          // 包装内容 / 包装内容选项：把整单顶层设置分发到 project_list 每一行，保持后端接口结构不变
          form.project_list = (form.project_list || []).map((it) => ({
            ...it,
            type_pack: form.type_pack,
            type_content: form.type_content,
          }));
          form.receive_data.province = form.receive_data.province.split("-")[0];
          form.send_data.province = form.send_data.province.split("-")[0];
          if (form.receive_data.remark || form.receive_data.remark == "") delete form.receive_data.remark;
          if (form.receive_data.id) delete form.receive_data.id;
          if (form.receive_data.user_type) delete form.receive_data.user_type;
          if (form.send_data.remark || form.send_data.remark == "") delete form.send_data.remark;
          if (!form.goods_info.hb_order_sn) form.goods_info.hb_order_sn = "";
          if (form.send_data.user_type) delete form.send_data.user_type;
          if (form.send_data.id) delete form.send_data.id;
          // AI订单打单后订单号继续以AI开头：优先用表单值，缺失时从列表行(record)兜底
          var aiOrderSn = (form.goods_info.order_sn && /^AI/.test(form.goods_info.order_sn))
            ? form.goods_info.order_sn
            : ((this.record && this.record.order_sn && /^AI/.test(this.record.order_sn)) ? this.record.order_sn : '');
          if (aiOrderSn) {
            form.goods_info.order_sn = aiOrderSn;
          } else {
            delete form.goods_info.order_sn;
          }
          this.orderLoading = true;
          createorder_new(form).then((res) => {
            this.orderLoading = false;
            if (res.code == 1 && res.data && res.data.status == 1) {
              this.$message.success(res.msg);
              if (this.id) {
                this.$emit("orderSuccess");
              } else {
                this.$router.push({ path: "/bill/list" });
              }
            } else {
              const errMsg = (res.code == 1 && res.data && res.data.text) ? res.data.text : (res.msg || '下单失败')
              this.$alert(errMsg.replace(/\n/g, '<br>'), '提示', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确认'
              })
            }
          }).catch((err) => {
            this.orderLoading = false;
            this.$message.error(this.$t('order.fplace.message.createOrderFailed'));
          });
        } else {
          return false;
        }
      });
    },
    storeForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let form = {
            ...this.ruleForm,
            user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
          };
          form = this.normalizePickupDate(form);
          let package_list = form.package_list.map((item) => {
            let pa_unit = this.pa_unit == this.$t('order.fplace.unit.lbIn') ? 1 : 2;
            return {
              ...item,
              pa_unit,
              pa_height: parseFloat(item.pa_height) || 1,
              pa_length: parseFloat(item.pa_length) || 1,
              pa_width: parseFloat(item.pa_width) || 1
            };
          });
          form.package_list = package_list;
          // 包装内容 / 包装内容选项：把整单顶层设置分发到 project_list 每一行，保持后端接口结构不变
          form.project_list = (form.project_list || []).map((it) => ({
            ...it,
            type_pack: form.type_pack,
            type_content: form.type_content,
          }));
          form.receive_data.province = form.receive_data.province.split("-")[0];
          form.send_data.province = form.send_data.province.split("-")[0];
          if (form.receive_data.remark || form.receive_data.remark == "") delete form.receive_data.remark;
          if (form.receive_data.id) delete form.receive_data.id;
          if (form.receive_data.user_type) delete form.receive_data.user_type;
          if (form.send_data.remark || form.send_data.remark == "") delete form.send_data.remark;
          if (!form.goods_info.hb_order_sn) form.goods_info.hb_order_sn = "";
          if (form.send_data.user_type) delete form.send_data.user_type;
          if (form.send_data.id) delete form.send_data.id;
          delete form.goods_info.order_sn;
          this.storeLoading = true;
          storeOrder_new(form).then((res) => {
            this.storeLoading = false;
            if (res.code == 1) {
              this.$message.success(res.msg);
              if (this.id) {
                this.$emit("orderSuccess");
              } else {
                this.$router.push({ path: "/bill/list" });
              }
            } else {
              this.$message.error(res.msg);
            }
          }).catch((err) => {
            this.storeLoading = false;
            this.$message.error(this.$t('order.fplace.message.createOrderFailed'));
          });
        } else {
          return false;
        }
      });
    },
    submitDraftForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 申报项目严格校验：防止字段错位
          const projectErr = this.validateProjectList(this.ruleForm.project_list);
          if (projectErr) {
            this.$message.error(projectErr);
            return;
          }
          let form = {
            ...this.ruleForm,
            user_code: JSON.parse(window.localStorage.getItem("userInfo1")).user_code,
          };
          form = this.normalizePickupDate(form);
          let package_list = form.package_list.map((item) => {
            let pa_unit = this.pa_unit == this.$t('order.fplace.unit.lbIn') ? 1 : 2;
            return {
              ...item,
              pa_unit,
              pa_height: parseFloat(item.pa_height) || 1,
              pa_length: parseFloat(item.pa_length) || 1,
              pa_width: parseFloat(item.pa_width) || 1
            };
          });
          form.package_list = package_list;
          // 包装内容 / 包装内容选项：把整单顶层设置分发到 project_list 每一行，保持后端接口结构不变
          form.project_list = (form.project_list || []).map((it) => ({
            ...it,
            type_pack: form.type_pack,
            type_content: form.type_content,
          }));
          form.receive_data.province = form.receive_data.province.split("-")[0];
          form.send_data.province = form.send_data.province.split("-")[0];
          if (form.q_data.province) form.q_data.province = form.q_data.province.split("-")[0];
          if (form.receive_data.remark || form.receive_data.remark == "") delete form.receive_data.remark;
          if (form.receive_data.id) delete form.receive_data.id;
          if (form.receive_data.user_type) delete form.receive_data.user_type;
          if (form.send_data.remark || form.send_data.remark == "") delete form.send_data.remark;
          if (form.send_data.user_type) delete form.send_data.user_type;
          if (form.send_data.id) delete form.send_data.id;
          if (!form.goods_info.hb_order_sn) form.goods_info.hb_order_sn = "";
          delete form.goods_info.order_sn;
          this.draftLoading = true;
          saveOrder_new(form).then((res) => {
            this.draftLoading = false;
            if (res.code == 1) {
              this.$message.success(res.msg);
              if (this.id) {
                this.$emit("orderSuccess");
              } else {
                this.$router.push({ path: "/bill/list" });
              }
            } else {
              this.$message.error(res.msg);
            }
          }).catch((err) => {
            this.draftLoading = false;
            this.$message.error(this.$t('order.fplace.message.saveDraftFailed'));
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.sendSelectValue = [];
      this.receiveSelectValue = [];
      this.sendProvinceList = [];
      this.receiveProvinceList = [];
      this.qProvinceList = [];
      this.pa_type_list = [
        { label: "Your 10kg Box" }, { label: "Your 25kg Box" }, { label: "Your Envelope" },
        { label: "Your Extra Large Box" }, { label: "Your Large Box" }, { label: "Your Medium Box" },
        { label: "Your Pak" }, { label: "Your Small Box" }, { label: "Your Tube" }, { label: "Your Packaging" },
      ];
      this.pa_unit = this.$t('order.fplace.unit.lbIn');
      this.FbaValue = "";
      this.freeInfo = {};
      this.checkInfo = {};
      this.ratesMoney = "";
      this.ratesWeight = "";
      this.ruleForm = {
        goods_info: { is_sign: 0, service_type: "", USPSEndorsement: 1, booking_confirmation_number: "" },
        // 包装内容 / 包装内容选项：整单一份的顶层总设置
        type_pack: this.$t('order.fplace.options.packageContent.item'),
        type_content: this.$t('order.fplace.options.itemTypes.commercial'),
        package_list: [{
          Sku: "001", insurance: 0, pa_height: '', pa_lb: "", pa_length: '',
          pa_num: 1, pa_type: "Your Packaging", pa_width: '', itemQty: 1
        }],
        project_list: [{
          code: "", unit_of: "", unit_price: "", product_info: "", pack_kind: "",
          num: "", suttle: "", chandi: ""
        }],
        receive_data: { company: "", address_two: "", address_three: "", email: "" },
        send_data: { company: "", address_two: "", address_three: "", email: "" },
        is_qu: 0,
        q_data: { company: "", address_two: "" },
        q_package: {},
      };
      this.is_qus = false;
      this.qendtimelist = [];
      this.$refs[formName].resetFields();
    },
    addParcel() {
      let obj = {
        Sku: "001", insurance: 0, pa_height: '', pa_lb: "", pa_length: '',itemQty: 1,
        pa_num: 1, pa_type: "Your Packaging", pa_width: '',
      };
      this.ruleForm.package_list.push(obj);
    },
    delParcel(num) {
      this.ruleForm.package_list.splice(num, 1);
    },
    copyParcel(num, item) {
      let pa_num = item.pa_num;
      if (item.pa_num > 1) {
        this.ruleForm.package_list[num].pa_num = 1;
        for (var i = 1; i < pa_num; i++) {
          let obj = { ...item, pa_num: 1 };
          this.ruleForm.package_list.push({ ...obj });
        }
      } else {
        this.ruleForm.package_list.push({ ...item });
      }
    },
    /**
     * 申报项目严格校验：防止字段错位（如把数字填到产地、把国家填到产品描述）
     * 校验通过返回空字符串，失败返回错误消息
     */
    validateProjectList(list) {
      if (!Array.isArray(list) || list.length === 0) return '';
      const validUnits = (this.unitList || []).map(x => x.label);
      const validCountries = (this.countryList || []).map(x => x.value);
      const numRe = /^-?\d+(\.\d+)?$/;

      for (let i = 0; i < list.length; i++) {
        const row = list[i] || {};
        const idx = i + 1;

        // 数量必须是数字
        if (row.num !== '' && row.num !== null && row.num !== undefined) {
          if (!numRe.test(String(row.num).trim())) {
            return `第${idx}行 ${this.$t('order.fplace.label.quantity')} 必须是数字`;
          }
        }
        // 净重必须是数字
        if (row.suttle !== '' && row.suttle !== null && row.suttle !== undefined) {
          if (!numRe.test(String(row.suttle).trim())) {
            return `第${idx}行 ${this.$t('order.fplace.label.netWeight')} 必须是数字`;
          }
        }
        // 商品价值必须是数字
        if (row.unit_price !== '' && row.unit_price !== null && row.unit_price !== undefined) {
          if (!numRe.test(String(row.unit_price).trim())) {
            return `第${idx}行 ${this.$t('order.fplace.label.productValue')} 必须是数字`;
          }
        }
        // 计量单位必须是预设值之一（避免被填成"computer processor"这种值）
        if (row.unit_of && validUnits.length > 0 && !validUnits.includes(String(row.unit_of).trim())) {
          return `第${idx}行 ${this.$t('order.fplace.label.unitOfMeasure')} 取值无效，请从下拉中选择`;
        }
        // 产地必须是预设国家之一（避免被填成"0.4"这种值）
        if (row.chandi && validCountries.length > 0 && !validCountries.includes(String(row.chandi).trim())) {
          return `第${idx}行 ${this.$t('order.fplace.label.origin')} 取值无效，请从下拉中选择国家`;
        }
        // 产品描述不能是纯数字（防止被错填成数量/价值）
        if (row.product_info && numRe.test(String(row.product_info).trim())) {
          return `第${idx}行 ${this.$t('order.fplace.label.productDescription')} 不能是纯数字`;
        }
      }
      return '';
    },
    addProject() {
      // 新增申报项目：不再包含 type_pack / type_content（这两个字段现在放在顶层 ruleForm）
      let obj = {
        code: "", unit_of: "", unit_price: "", product_info: "", pack_kind: "",
        num: "", suttle: "", chandi: ""
      };
      this.ruleForm.project_list.push(obj);
    },
    delProject(num) {
      this.ruleForm.project_list.splice(num, 1);
    },
  },
};
</script>
<style lang="scss" scoped>
.place {
  background: #fff;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
  overflow-y: scroll;
  .place-title {
    width: 100%;
    font-size: 15px;
    line-height: 24px;
    text-align: left;
    color: #409eff;
  }
  .border-col {
    border-bottom: 1px solid #409eff;
    margin-bottom: 10px;
    padding-bottom: 5px;
  }
}
/deep/.el-form-item__content {
  text-align: left;
}
.add-select-btn {
  margin-left: 30px;
}
.parcel-item,
.parcel-item1 {
  width: 100%;
  background: rgba(64, 158, 255, 0.1);
  border-radius: 5px;
  box-sizing: border-box;
  padding: 10px;
  margin-bottom: 10px;
  .parcel-item-label {
    font-size: 14px;
    text-align: left;
    margin: 5px 0;
  }
  .parcel-top {
    width: 100%;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #bee6f7;
    margin-bottom: 10px;
    padding-bottom: 10px;
    .parcel-title {
      font-size: 14px;
    }
  }
  .parcel-lwh {
    display: flex;
    align-items: center;
    /deep/ input::-webkit-outer-spin-button,
    /deep/ input::-webkit-inner-spin-button {
      -webkit-appearance: none !important;
    }
    /deep/ input[type="number"] {
      -moz-appearance: textfield;
    }
  }
  .place-box {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
}
.tips {
  font-size: 14px;
  color: red;
  padding-left: 10px;
}
.bttn {
  text-align: right;
  margin-top: 10px;
  font-size: 14px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.free-rate {
  font-size: 14px;
  display: flex;
  align-items: center;
  margin: 0 10px;
  span {
    color: #e6a23c;
    font-size: 16px;
  }
}
.check-dialog {
  /deep/.el-dialog__body {
    padding: 0 20px !important;
  }
}
</style>
